// extracted by mini-css-extract-plugin
export var country = "index-module--country--441e8";
export var img = "index-module--img--dc3d8";
export var label = "index-module--label--14c31";
export var labels = "index-module--labels--ee91f";
export var marks = "index-module--marks--ca133";
export var moreProduct = "index-module--more-product--13d37";
export var productItem = "index-module--product-item--ec997";
export var productList = "index-module--product-list--fec30";
export var title = "index-module--title--55ac7";